import Link from '@mui/material/Link';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import {
  GridColumns, GridColDef, GridRenderCellParams,
  GridRowsProp, GridValueFormatterParams, GRID_CHECKBOX_SELECTION_COL_DEF
} from '@mui/x-data-grid-pro';
import { createActionsColumn } from './actionsColumn';
import { formatSignatureStatus, SignatureStatus } from '../enums/signatureStatus';
import Tooltip from '@mui/material/Tooltip';
import { getPendingSignatureTooltip } from '../enums/pendingSignatureTooltip';

export const pafViewColumns: GridColDef[] = [

  // { field: 'paf_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  // },
   createActionsColumn({
    showView: true,
    showEdit: true,
    getViewUrl: (row: any) => `/paf/${row.paf_id}?mode=view`,
    getEditUrl: (row: any) => `/paf/${row.paf_id}`,
    shouldShowEdit: (row: any) => {
      // Never show edit for EXPIRED status
      if (row.signature_status === 'EXPIRED') return false;
      // Allow edit (and thus e-sign) if pending_signatures is exactly ['list_owner']
      if (Array.isArray(row.pending_signatures) && row.pending_signatures.length === 1 && row.pending_signatures[0] === 'list_owner') {
        return true;
      }
      return row.signature_status !== 'APPROVED' && row.signature_status !== 'WAITING_APPROVAL' && row.signature_status !== 'WAITING_SIGNATURES';
    },
    iconGapPx: 16,
  }),
  {
    field: 'paf_sid',
    type: 'string',
    headerName: 'PAF SID',
    width: 125,
  },
  {
    field: 'company__company_name',
    type: 'string',
    headerName: 'Company Name',
    width: 250,
  },
  {
    field: 'signature_status',
    type: 'string',
    headerName: 'Status ',
    width: 150,
    sortable: false,
    renderCell: (params: GridRenderCellParams<any>) => {
      const pendingSignatures = params.row?.pending_signatures || [];
      const tooltipMsg = getPendingSignatureTooltip(pendingSignatures);
      // Always use enum value for status
      let statusKey = params.value as string;
      // fallback for legacy string values
      if (statusKey === 'Waiting Signatures') statusKey = SignatureStatus.WAITING_SIGNATURES;
      if (statusKey === 'Waiting Approval') statusKey = SignatureStatus.WAITING_APPROVAL;
      if (statusKey === 'Approved') statusKey = SignatureStatus.APPROVED;
      if (statusKey === 'Rejected') statusKey = SignatureStatus.REJECTED;
      if (statusKey === 'Expired') statusKey = SignatureStatus.EXPIRED;
      const statusLabel = formatSignatureStatus(statusKey);
      return tooltipMsg ? (
        <Tooltip title={tooltipMsg} arrow>
          <span>{statusLabel}</span>
        </Tooltip>
      ) : (
        <span>{statusLabel}</span>
      );
    },
  },
  // {
  //   field: 'company__state',
  //   type: 'string',
  //   headerName: 'State',
  //   width: 100,
  // },
  {
    field: 'company__naics_code',
    type: 'string',
    headerName: 'NAICS',
    width: 100,
  },
  {
    field: 'company__representative_name',
    type: 'string',
    headerName: 'Contact Name',
    width: 150,
  },
  {
    field: 'company__representative_title',
    type: 'string',
    headerName: 'Contact Title',
    width: 150,
  },
  {
    field: 'company__representative_email',
    type: 'string',
    headerName: 'Contact Email',
    width: 150,
  },
  {
    field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 175,
  },
];

// Utility to match edit icon logic for checkbox selection
export const isRowSelectable = (row: any) => {
  // Never allow selection for EXPIRED status
  if (row.signature_status === 'EXPIRED') return false;
  // Never allow selection for REJECTED status
  if (row.signature_status === 'REJECTED') return false;
  if (Array.isArray(row.pending_signatures) && row.pending_signatures.length === 1 && row.pending_signatures[0] === 'list_owner') {
    return true;
  }
  return row.signature_status !== 'APPROVED' && row.signature_status !== 'WAITING_APPROVAL' && row.signature_status !== 'WAITING_SIGNATURES';
};

export const pafFilesColumns: GridColDef[] = [
  // { field: 'file_id',
  //   type: 'number',
  //   headerName: 'ID',
  //   width: 80,
  // },
  {
    field: 'persisted_file_url',
    // type: 'string',
    headerName: 'Url',
    align: "center",
    filterable: false,
    sortable: false,
    resizable: false,
    pinnable: false,
    disableColumnMenu: true,
    width: 56,
    renderCell: (params: GridRenderCellParams<string>) => {
      return (
        <Link href={`${params.value}`} target="_blank" rel="noopener"><CloudDownloadIcon /></Link>
      );
    }
  },
  {
    field: 'name',
    type: 'string',
    headerName: 'Name',
    width: 400,
  },
  {
    field: 'size_in_bytes',
    type: 'number',
    headerName: 'Size in Bytes',
    width: 120,
  },
  {
    field: 'modify_datetime',
    type: 'dateTime',
    headerName: 'Last Modified',
    width: 176,
  },
  {
    field: 'modify_user',
    type: 'string',
    headerName: 'Last Modified User',
    width: 184,
  },
];

export const pafFilesPinnedColumns = {
  left: [
    GRID_CHECKBOX_SELECTION_COL_DEF.field,
    "persisted_file_url"
  ],
}